<template>
  <div v-if="pdfUrl1 == '' || pdfUrl1 == undefined">
    <iframe id="pdfPlayer" :src="'../../../js/pdfjs/web/viewer.html?file=' + pdfUrl" frameborder="0" width="100%" :height="height"></iframe>
  </div>
  <div v-else>
    <iframe id="pdfPlayer" :src="'../../../js/pdfjs/web/viewer.html?file=' + pdfUrl" frameborder="0" width="50%" :height="height"></iframe>
    <iframe id="pdfPlayer" :src="'../../../js/pdfjs/web/viewer.html?file=' + pdfUrl1" frameborder="0" width="50%" :height="height"></iframe>
  </div>
</template>

<script>
export default {
  props: {
    asPartial: {
      type: Boolean,
      default: false
    },
    pdfUrl: {
      type: String
    },
    pdfUrl1: {
      type: String
    },
    fileId: {
      type: String,
      default: '0'
    },
    fileId1: {
      type: String,
      default: '0'
    },
    height: {
      type: String,
      default: '600px'
    }
  },
  data() {
    return {}
  },
  mounted() {
    // window.console.log("pdfViewer");
    // window.console.log(this.$route.query.pdfUrl1);
    // window.console.log(this.$route.query.fileId);
    let header = document.getElementsByClassName('MemberHeader')
    if (!this.asPartial) {
      let offsetHeight = header == null || header == 'undefined' ? 0 : parseInt(header[0].clientHeight)
      let h = (document.documentElement.clientHeight || document.body.clientHeight) - 10 - offsetHeight
      this.height = h + 'px'
      this.fileId = typeof this.$route.query.fileId == 'undefined' || this.$route.query.fileId == '' ? '0' : this.$route.query.fileId
      this.fileId1 = typeof this.$route.query.fileId1 == 'undefined' || this.$route.query.fileId1 == '' ? '0' : this.$route.query.fileId1
      this.pdfUrl = this.$route.query.pdfUrl
      this.pdfUrl1 = typeof this.$route.query.pdfUrl1 == 'undefined' ? '' : this.$route.query.pdfUrl1
    }
    if (this.fileId != '0') {
      this.fnConvertFile2PDF(this.fileId)
    }
    if (this.fileId1 != '0') {
      this.fnConvertFile2PDF1(this.fileId1)
    }
  },
  methods: {
    fnConvertFile2PDF(fileId) {
      // let suffix = pdfUrl.substring(name.lastIndexOf(".") + 1)
      let config = {
        params: {
          fileId: fileId
        }
      }
      this.getRequest('/Common/ConvertFile2PDF', config).then((res) => {
        if (res.data.errcode == 'OK') {
          this.pdfUrl = window.location.origin + res.data.url
        } else {
          window.console.log(res.data.url)
        }
      })
    },
    fnConvertFile2PDF1(fileId) {
      // let suffix = pdfUrl.substring(name.lastIndexOf(".") + 1)
      let config = {
        params: {
          fileId: fileId
        }
      }
      this.getRequest('/Common/ConvertFile2PDF', config).then((res) => {
        if (res.data.errcode == 'OK') {
          this.pdfUrl1 = window.location.origin + res.data.url
        } else {
          window.console.log(res.data.url)
        }
      })
    }
  }
}
</script>

<style></style>
